import LandingPageLayout from "../layouts/LandingPageLayout"

function AccessDenied(): JSX.Element {
  return <LandingPageLayout pageTitle={'Access Denied | CSTL'}>
    <div className="flex flex-col h-full w-full justify-center items-center">
      <div className="w-2/6 text-center p-5">
        <p className="text-royalBlue font-medium text-2xl">
          401 | Access Denied
        </p>
      </div>
    </div>
  </LandingPageLayout>
}

export default AccessDenied